<template>
  <div class="left-filter">
    <div class="item seperates categories">
      <h3 @click="setCategory">
        <i v-if="filter.categoryId" class="iconfont icon-jiantou-zuo-cu" />
        All Categories
        <i
          :class="'iconfont icon-' + (categoryCollapsed ? 'jiahao-cu' : 'henggang-jiacu')"
          @click.stop="collapse('category')"
        ></i>
      </h3>
      <div v-show="!categoryCollapsed" class="category-tree">
        <category-new
          ref="categoryTreeRef"
          :filter="filter"
          :max-level="categoryMaxLevel"
          @setCategory="setCategory"
        />
      </div>
    </div>

    <div class="item seperates brands">
      <a-spin :spinning="isSearchingBrands">
        <h3>
          Brands
          <i
            :class="'iconfont icon-' + (brandCollapsed ? 'jiahao-cu' : 'henggang-jiacu')"
            @click.stop="collapse('brand')"
          ></i>
        </h3>
        <a-input-search
          v-if="!brandCollapsed"
          v-model:value="brandSearch.brandName"
          allow-clear
          placeholder="Search Brand..."
          @change="getBrandsList"
        />
        <div v-if="!brandCollapsed" class="brands-list" @scroll="loadMoreBrands">
          <a-checkbox
            v-for="(brand, index) in brands"
            :key="brand.brandName"
            class="brand-item"
            :checked="brand.selected"
            @change="setFilter('brand', { ...brand, index })"
          >
            {{ brand.brandName }}
          </a-checkbox>
          <a-spin size="small" class="loading-more" :spinning="isLoadingBrands" />
        </div>
      </a-spin>
    </div>
  </div>
</template>

<script setup>
import { ref, defineExpose } from 'vue'
import CategoryNew from '~/components/CategoryNew.vue'

defineProps({
  filter: {
    type: Object,
    required: true,
  },
  categoryCollapsed: {
    type: Boolean,
    required: true,
  },
  categoryMaxLevel: {
    type: Number,
    default: 0,
  },
  brandCollapsed: {
    type: Boolean,
    required: true,
  },
  isSearchingBrands: {
    type: Boolean,
    required: true,
  },
  brandSearch: {
    type: Object,
    required: true,
  },
  brands: {
    type: Array,
    required: true,
  },
  isLoadingBrands: {
    type: Boolean,
    required: true,
  },
  setCategory: {
    type: Function,
    required: true,
  },
  collapse: {
    type: Function,
    required: true,
  },
  getBrandsList: {
    type: Function,
    required: true,
  },
  loadMoreBrands: {
    type: Function,
    required: true,
  },
  setFilter: {
    type: Function,
    required: true,
  },
})

const categoryTreeRef = ref(null)

const getCategories = (payload) => {
  categoryTreeRef.value?.getCategories(payload)
}

defineExpose({
  getCategories,
})
</script>

<style scoped lang="less">

.left-filter {
  // Left filter panel styles extracted from products page.
  flex: 0 0 215px;
  margin-right: 20px;

  .item {
    &:last-of-type {
      margin-bottom: 16px;
    }
  }

  h3 {
    display: flex;
    font-size: 16px;
    font-weight: 500;
    align-items: center;
    margin-bottom: 10px;

    > .iconfont {
      width: auto;
      height: auto;
      color: var(--dark-3);

      &.icon-henggang-jiacu,
      &.icon-jiahao-cu {
        flex: 1;
        text-align: right;
      }
    }

    .icon-jiantou-zuo-cu {
      width: 16px;
      height: 16px;
      font-size: 14px;
      line-height: 16px;
      margin-right: 4px;
      color: var(--dark-2);
    }
  }

  .categories > h3 {
    cursor: pointer;
  }

  .category-tree {
    margin-left: 10px;
  }

  .brands-list {
    margin-top: 6px;
    overflow-y: auto;
    max-height: 187px;
  }

  .loading-more {
    display: flex;
    font-size: 12px;
    margin-top: 2px;
    align-items: center;
    justify-content: center;

    .ant-spin-text {
      margin-left: 6px;
    }
  }

  .brand-item {
    width: 200px;
    height: 30px;
    display: flex;
    line-height: 30px;
    font-weight: normal;

    &:hover,
    &.ant-checkbox-wrapper-checked {
      color: var(--dark-1);
    }

    :deep(> span:last-of-type) {
      overflow: hidden;
      white-space: nowrap;
      padding-inline-end: 0;
      text-overflow: ellipsis;
      flex: 0 0 calc(100% - 16px);
    }
  }

  .seperates {
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid var(--border-4);
  }
}
</style>
